module.exports = __webpack_public_path__ + "static/media/advertiseBg.5ac6ed59.png";